export default "__VITE_ASSET__d41e7ea5__"